import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    width: "27",
    height: "26",
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<circle cx="13.7079" cy="12.8632" r="12.3446" fill="#193446" stroke="#fff"/> <path d="M14.6757 18.1562h-1.6064v-6.4531c0-.7702.0182-1.3808.0547-1.832-.1049.1094-.2347.2301-.3897.3623-.1504.1322-.6608.5514-1.5312 1.2578l-.8067-1.0185 2.9395-2.3106h1.3398v9.9941Z" fill="#fff"/>' }
  })
);